import Vue, {VueConstructor} from 'vue';

declare module 'vue/types/vue' {
  interface Vue {
    $isDemoModeEnabled(): boolean;

    $isDisabledInDemo(additionalCondition?: boolean): boolean;
  }
}

const demoHelper = {
  install(Vue: VueConstructor<Vue>) {
    Vue.prototype.$isDemoModeEnabled = function (): boolean {
      // Use traditional syntax instead of optional chaining and nullish coalescing
      const store = this.$store;
      if (store && store.state && typeof store.state.demoProfileActive !== 'undefined') {
        return store.state.demoProfileActive;
      }
      return false;
    };

    Vue.prototype.$isDisabledInDemo = function (additionalCondition: boolean = false): boolean {
      return this.$isDemoModeEnabled() || additionalCondition;
    };
  }
};

export default demoHelper;
